export default __webpack_public_path__ + "static/media/Sana.2416f821.mp3";